import {
  SET_PROCEDURE_FILTERS,
  RESET_PROCEDURE_FILTERS,
  SET_PROCEDURE_GRID_SORT_CRITERIA,
} from './actionTypes';

export const setProcedureFilters = filters => ({
  type: SET_PROCEDURE_FILTERS,
  filters,
});

export const cleanProcedureFilters = () => ({
  type: RESET_PROCEDURE_FILTERS,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_PROCEDURE_GRID_SORT_CRITERIA,
  sortCriteria,
});
